import { ClientLambdaApi } from '@/api-client.js'
import AgGrid from '@/app/shared/models/AgGrid.js'

const getLongGrid = async (longGridPayload) => {
  const longGrid = await ClientLambdaApi.post('/long-grid-data/', longGridPayload)
  return new AgGrid(longGrid.data)
}

const salesTwoRanges = async (payload) => {
  const response = await ClientLambdaApi.post('/sales-two-ranges/', { parameters: payload.parameters })
  if (response.status !== 200) {
    throw new Error('Error al obtener el status de venta')
  }
  return response.data
}

const downloadGridToXlsx = async (payload) => {
  const data = { parameters: payload.parameters }
  const downloadGridPromise = await ClientLambdaApi.post('/download-grid-data-to-xlsx/', data, { responseType: 'blob' })
  try {
    downloadFile(downloadGridPromise, 'datos_grilla.xlsx')
  } catch (e) {
    throw new Error('Error al descargar el excel')
  }
}

const downloadFile = async (downloadPromise, filename) => {
  const download = require('js-file-download')
  const response = await downloadPromise
  if (response.status !== 200) {
    throw new Error('Error al descargar el archivo')
  }
  download(response.data, filename)
}

const pivotSales = async (parameters) => {
  const response = await ClientLambdaApi.post('/pivot-sales/',
    {
      parameters: parameters.parameters,
      pivotParameters: parameters.pivotParameters
    }
  )
  if (response.status === 204) {
    throw new Error('No hay datos para la opción seleccionada')
  } else if (response.status !== 200) {
    throw new Error('Error en request pivot-sales')
  }
  return response.data
}

export { salesTwoRanges, downloadGridToXlsx, pivotSales, getLongGrid, downloadFile }



// WEBPACK FOOTER //
// ./src/app/shared/Services.js